
import { Helmet, HelmetProvider } from 'react-helmet-async';
import PeoplePurposeHeroSection from '../components/PeoplePurpose/HeroSection'
import MeetTeam from '../components/PeoplePurpose/MeetTeam'
import ProfileCard from '../components/PeoplePurpose/ProfileCard'
import ProfileInto from '../components/PeoplePurpose/ProfileInto'
import AwardsRecognitions from '../components/PeoplePurpose/AwardsRecognitions'
import "../styles/_peoplpurpose.scss"


const PeoplePurpose = () => {
  return (
    <>
      <HelmetProvider>
      <Helmet>
        <title>People & Purpose | Brand Acumen</title>
        <meta name="description" content="Explore the services offered by Brand Acumen." />
        <meta name="description" content="Welcome to the homepage of Brand Acumen." />
        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Home | Brand Acumen" />
        <meta property="og:description" content="Welcome to the homepage of Brand Acumen." />
        <meta property="og:image" content="/og-image.jpg" />
        <meta property="og:url" content="https://brandacumen.co/" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:title" content="Home | Brand Acumen" />
        <meta name="twitter:description" content="Welcome to the homepage of Brand Acumen." />
        <meta name="twitter:image" content="/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
      
      <PeoplePurposeHeroSection />
      <ProfileInto />
      <ProfileCard/>
      <MeetTeam />
      <AwardsRecognitions />
      </HelmetProvider>
    </>
  );
};

export default PeoplePurpose;